<template>
  <div class="container" style="margin-top: 50px">
    <div class="row">
      <div class="col-md-3">
        <h4 class="heading-primary">Cek Password</h4>
      </div>
      <div class="col-md-9">
        <center>
          <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
        </center>
        <flash-message></flash-message>
        <!-- <breadcrumb :list="breadcrumbList"/>
        <div class="alert alert-success" style="margin-bottom: 15px">
          <strong>Cek Password Pembayaran</strong>
        </div> -->
        <form class="form-horizontal">
          <div class="form-group">
            <label class="col-md-3">Nomor Pembayaran / Nomor Billing</label>
            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                placeholder="98xxxxxxxxx"
                v-model="nomorPembayaran"
              >
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-3">Nomor Pendaftar / KODE</label>
            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                placeholder="132xxxxx"
                v-model="nomorPendaftar"
              >
            </div>
          </div>
          <div class="form-group" style="margin-right: 5px">
            <div class="col-md-3">
              <a class="btn btn-primary pull-left" style="min-width: 70px" @click="getData">Cari</a>
            </div>
            <div class="col-md-4">
            </div>
          </div>
        </form>
        <hr>
        <div v-if="model">
          <table>
            <tr>
              <td width="200px">KODE PMB</td>
              <td> : {{model.KODE_PMB}}</td>
            </tr>
            <tr>
              <td>PIN PMB</td>
              <td> : {{model.PIN_PMB}}</td>
            </tr>
            <tr>
              <td>Tanggal Bayar</td>
              <td> : {{model.TGL_BAYAR}}</td>
            </tr>
            <tr>
              <td>Kode Bayar</td>
              <td> : {{model.KODE_PREFIX}}</td>
            </tr>
          </table>
          <br>
          <div class="alert alert-success">
            Gunakan KODE PMB dan PIN PMB untuk masuk ke Formulir Pendaftaran
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import laporan from '@/helper/laporan'

export default {
  data () {
    return {
      loading: false,
      nomorPendaftar: null,
      nomorPembayaran: null,
      model: null
    }
  },
  mounted () {
    // let header = document.getElementsByClassName('page-header')
    // header.style.display = 'none'
    $('.page-header').hide()
  },
  computed: {
    breadcrumbList () {
      let list = this.$route.path.split('/')
      list.shift()
      for (let i = 0; i < list.length; i++) {
        list[i] = list[i].replace(/_/g, ' ')
      }
      return list
    }
  },
  methods: {
    getData () {
      let error = !this.nomorPembayaran || !this.nomorPendaftar
      error ? this.flash('nomor pembayaran / nomor pendaftar tidak boleh kosong', 'error') : this._getData()
    },
    async _getData () {
      this.loading = true
      try {
        this.model = await laporan.cekPassPub(this.nomorPembayaran, this.nomorPendaftar)
        this.loading = false
      } catch (e) {
        // Tell the user if error happend
        e.data ? this.flash(e.data.message, 'error') : this.flash('error happend, please tell the developer', 'error')
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/CekPembayaranPub.vue